import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { CreateNotePage } from './create-note.page';
import { AdFileUploadModule } from 'ad-file-upload';
import { ComponentsModule } from 'src/app/components/components.module';

const routes: Routes = [
  {
    path: '',
    component: CreateNotePage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    AdFileUploadModule,
    ComponentsModule,
    RouterModule.forChild(routes)
  ],
  declarations: [CreateNotePage]
})
export class CreateNotePageModule {}
